import React from 'react';
import {
    useReactTable,
    getCoreRowModel,
    flexRender,
    getSortedRowModel,
    getFilteredRowModel,
} from '@tanstack/react-table';
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import Pagination from '../DaisyTable/Pagination/Pagination';

const TanstackTable = ({
    data,
    columns,
    onRowClick,
    globalFilter,
    setGlobalFilter,
    getRowClassName,
    sorting,
    setSorting,
    renderExpandedContent
}) => {
    // Si sorting et setSorting sont fournis, utilisez-les sinon utilisez l'état local
    const [localSorting, setLocalSorting] = React.useState([]);

    const table = useReactTable({
        data,
        columns,
        state: {
            sorting: sorting || localSorting,
            globalFilter,
        },
        onSortingChange: setSorting || setLocalSorting,
        onGlobalFilterChange: setGlobalFilter,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
    });

    return (
        <div className="space-y-4">
            <div className="overflow-x-auto">
                <table className="table  w-full">
                    <thead>
                        {table.getHeaderGroups().map(headerGroup => (
                            <tr key={headerGroup.id}>
                                {headerGroup.headers.map(header => (
                                    <th
                                        key={header.id}
                                        className="cursor-pointer select-none"
                                        onClick={header.column.getToggleSortingHandler()}
                                    >
                                        <div className="flex items-center gap-2">
                                            {flexRender(
                                                header.column.columnDef.header,
                                                header.getContext()
                                            )}
                                            {{
                                                asc: <ChevronUpIcon className="w-4 h-4" />,
                                                desc: <ChevronDownIcon className="w-4 h-4" />,
                                            }[header.column.getIsSorted()] ?? null}
                                        </div>
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody>
                        {table.getRowModel().rows.map(row => {
                            const customClassName = getRowClassName ? getRowClassName(row.original) : '';
                            return (
                                <React.Fragment key={row.id}>
                                    <tr
                                        className={`${onRowClick ? 'cursor-pointer hover:bg-primary/10 transition-all duration-150' : ''} ${customClassName}`}
                                        onClick={() => onRowClick?.(row)}
                                    >
                                        {row.getVisibleCells().map(cell => (
                                            <td key={cell.id} className={cell.column.columnDef.cellClassName}>
                                                {flexRender(
                                                    cell.column.columnDef.cell,
                                                    cell.getContext()
                                                )}
                                            </td>
                                        ))}
                                    </tr>
                                    {renderExpandedContent && renderExpandedContent(row.original) && (
                                        <tr className="border-0 hover:bg-transparent">
                                            <td colSpan={columns.length} className="p-0 border-0">
                                                {renderExpandedContent(row.original)}
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            <div className="flex justify-between items-center">
                <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-700">
                        {table.getFilteredRowModel().rows.length} résultats
                    </span>
                </div>
            </div>
        </div>
    );
};

export default TanstackTable; 